export type MemberAccountStatus = "active" | "disabled" | "archived";
export type MemberListView = "current" | "archived";

export type MemberArchiveListRecord = {
  accountStatus?: MemberAccountStatus | null;
};

/**
 * Archived is a durable account state, while disabled accounts remain visible in
 * the current CRM list so staff can still diagnose and manage them. This keeps
 * the two-view UI exhaustive without misclassifying a disabled account as
 * archived.
 */
export function isArchivedMemberRecord(record: MemberArchiveListRecord) {
  return record.accountStatus === "archived";
}

export function filterMemberRecordsByListView<T extends MemberArchiveListRecord>(
  records: T[],
  view: MemberListView,
) {
  const shouldShowArchived = view === "archived";
  return records.filter(record => isArchivedMemberRecord(record) === shouldShowArchived);
}
